var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, ofType, Actions } from '@ngrx/effects';
import { map, switchMap, catchError, tap } from 'rxjs/operators';
import { ApiService } from '@api/service';
// import * as UserAction from '../actions/user.action';
import * as appAction from './../actions';
import { Store } from '@ngrx/store';
import { of } from 'rxjs/internal/observable/of';
var UserEffects = /** @class */ (function () {
    function UserEffects(actions$, api, store) {
        var _this = this;
        this.actions$ = actions$;
        this.api = api;
        this.store = store;
        this.getUser$ = this.actions$.pipe(ofType(appAction.getUser), switchMap(function () {
            return _this.api.user.whoAmI().pipe(tap(function (user) {
                window['app'] = window['app'] || {};
                window['app'].features = user.features;
            }), map(function (user) { return appAction.getUserSuccess(user); }), catchError(function (err) { return of(appAction.getUserFail(err)); }));
        }));
        this.logout$ = this.actions$.pipe(ofType(appAction.logoutUser), switchMap(function () {
            return _this.api.user.logout().pipe(tap(function () { return _this.store.dispatch(new appAction.Go({ path: ['welcome'] })); }), map(function () { return appAction.logoutUserSuccess(); }), catchError(function (err) { return of(appAction.logoutUserFail(err)); }));
        }));
        this.login$ = this.actions$.pipe(ofType(appAction.loginUser), switchMap(function (req) {
            return _this.api.oauth.passwordAuth(req).pipe(tap(function (res) {
                if (res && res.role) {
                    _this.store.dispatch(new appAction.Go({ path: ['recipes'] }));
                }
                else {
                    appAction.loginUserFail({ error: null });
                }
            }), map(function (res) { return appAction.loginUserSuccess(res); }), catchError(function (err) { return of(appAction.loginUserFail(err)); }));
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], UserEffects.prototype, "getUser$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], UserEffects.prototype, "logout$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], UserEffects.prototype, "login$", void 0);
    return UserEffects;
}());
export { UserEffects };
